import React from "react";
import { Stack } from "basis";
import styled from "styled-components";

import { COUNTRY } from "../core/constants";
import { assetsBaseUrl } from "../core/config";

const StyledImage = styled.img`
  height: ${({ isVertical }) => (isVertical ? "55px" : "35px")};
  margin-right: 5px;
  display: block;
`;

export default ({ country = COUNTRY.AU, showApplyLogos, checkoutTemplate }) => {
  let logos;
  
  if (country === COUNTRY.NZ) {
    logos = ["GemVisaNZ_Vertical.png"];
  } else {
    // AU logos - show GO first only when checkoutTemplate is specifically "HN"
    logos = checkoutTemplate === "HN" 
      ? ["GOPMC_V1.png", "GEMVISA_V1.png"]
      : ["GEMVISA_V1.png", "GOPMC_V1.png"];
  }

  if(showApplyLogos){
    logos = ["Go.png", "Creditline.png", "BuyersEdge.png"]
  }

  return (
    <Stack data-testid={country} gap="2" direction="horizontal">
      <div style={{ display: "flex", alignItems: "center" }}>
        {logos.map((logo) => (
          <StyledImage
            key={logo}
            src={`${assetsBaseUrl}/latitude/acceptedCard/${logo}`}
            isVertical
          />
        ))}
      </div>
    </Stack>
  );
};
